import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import OwlCarousel, { Options } from 'react-owl-carousel';


class ClientSection extends Component {

	state= {
        responsive:{
            0: {
                items: 1,
            },
           500: {
                items: 1,
            },
            768: {
                items: 2,
            },
            1000: {
                items: 3,
            },
        },
    }

	
render() {
    return (
        <div>
        <div className="container">
                    <div className="testimonial-heading text-center">
                        <div className="col-12">
                            <h2>What our clients are saying</h2>
                        </div>
                    </div>
        </div>

<div className="testimonial-section">
	
	<div className="container">
		<div className="col-12">
	<OwlCarousel items={3} autoplay={true} responsiveClass={true}
	 responsive={this.state.responsive}
	
		className="owl-theme"	
		  loop
		
		    
         >  
           <div className="col-md-auto">
				<div className="testimonial-shadow">
					<div className="quote">
 						<img src={"./img/quote.png"} alt="" />
 		            </div>
 						 <p>Thanks a lot for the quick response. I was really impressed, your solution is excellent! Your competence is justified!
        				 </p>
         			<div className="image">
         				<img src={"./img/1.jpg"} alt="" />
        				 </div>
 					<div className="name">Hanna Barbara</div>
 					<div className="designation">Marketer</div>
 	    		</div>
					
			</div>
			<div className="col-md-auto">
				<div className="testimonial-shadow">
					<div className="quote">
 						<img src={"./img/quote.png"} alt="" />
 		            </div>
 						 <p>Thanks a lot for the quick response. I was really impressed, your solution is excellent! Your competence is justified!
        				 </p>
         			<div className="image">
         				<img src={"./img/2.jpg"} alt="" />
        				 </div>
 					<div className="name">Charlie Puth</div>
 					<div className="designation">Product Manager</div>
 	    		</div>
					
			</div>
			<div className="col-md-auto">
				<div className="testimonial-shadow">
					<div className="quote">
 						<img src={"./img/quote.png"} alt="" />
 		            </div>
 						 <p>Thanks a lot for the quick response. I was really impressed, your solution is excellent! Your competence is justified!
        				 </p>
         			<div className="image">
         				<img src={"./img/3.jpg"} alt="" />
        				 </div>
 					<div className="name">Ed Sheeran</div>
 					<div className="designation">Brand Manager</div>
 	    		</div>
					
			</div>
			
      </OwlCarousel>    
	  </div>
    </div>
</div>
<div className="container contactus">
  <div className="row mb-4">
    <div className="col-lg-8 col-sm-12 align-self-center">
		<div className="d-flex justify-content-center">
		<span className="contact-text">Are you ready to work with us? Get in touch now!</span>
		</div>
      
        
     
    </div>
    <div className="col-lg-4 col-sm-12 align-self-center">
      <div className="d-flex justify-content-center">
		 <Link to="/ContactUs" className="contact-button"> CONTACT US NOW </Link>
      </div>
    </div>
  </div>
</div>
</div>
    )
}
}

export default ClientSection